<template>
	<div class="maintenance-mode">
		<h1>We will be back shortly. Thank you for your patience.</h1>
	</div>
</template>

<script lang="ts" setup></script>

<style scoped>
.maintenance-mode {
	display: flex;
	position: fixed;
	top: 0;
	left: 0;
	justify-content: center;
	align-items: flex-end;
	z-index: 9999;
	background-image: url("../assets/images/migration.webp");
	background-position: center center;
	background-size: cover;
	background-repeat: no-repeat;
	padding: 0 1.5rem 8vh;
	width: 100vw;
	height: 100vh;
	color: white;
	text-align: center;
}

h1 {
	font-size: 1.5rem;
}
</style>
